<div class="vault-results">
  <!-- Current selection -->
  <div class="atmos-card">
    <div class="atmos-card__header">
      <h2 class="atmos-section__title">Selection</h2>
    </div>
    <div class="atmos-card__body">
      <div class="selection-icons">
        @for (type of selectionTypes; track type) {
          @let item = currentSelection()[type];
          @if (item) {
            <div class="selection-icon selected is-static" [skyTooltip]="item.name">
              <app-item-icon [item]="item" [size]="'default'" class="selection-icon-img"
                [opaque]="true"></app-item-icon>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <!-- Results list -->
  <div class="atmos-card">
    <div class="atmos-card__header">
      <h2 class="atmos-section__title">Results</h2>
    </div>
    <div class="atmos-card__body">
      @if (apiData()) {
        @for (result of results; track result.data.id) {
          <div class="vault-result">
            <!-- Result items -->
            <div class="selection-icons">
              @for (type of selectionTypes; track type) {
                @let item = result.items[type];
                @if (item) {
                  <div class="selection-icon is-static" [class.selected]="item" [skyTooltip]="item?.name || (type | itemType)">
                    <app-item-icon [item]="item" [size]="'default'" class="selection-icon-img"
                      [opaque]="true"></app-item-icon>
                  </div>
                }
              }
            </div>

            <!-- Metadata -->
            <div class="vault-result__meta">
              <span skyTooltip="Player size">
                <mat-icon svgIcon="resize"></mat-icon>
                {{ result.data.sizeId && sizes[result.data.sizeId] || sizes[0] }}
              </span>
              <span skyTooltip="Lighting">
                <mat-icon svgIcon="bonfire"></mat-icon>
                {{ result.data.lightingId && lightings[result.data.lightingId] || lightings[0] }}
              </span>
            </div>

            <!-- Links -->
            <div class="vault-result__actions">
              @if (result.data.protocolLink) {
                <a [href]="result.data.protocolLink" target="_blank" rel="noopener" class="atmos-btn atmos-btn--sm">
                  <mat-icon>desktop_windows</mat-icon>
                  <span>Open on PC</span>
                </a>
              }
              <a [href]="result.data.link" target="_blank" rel="noopener" class="atmos-btn atmos-btn--sm">
                <mat-icon>open_in_browser</mat-icon>
                <span>Go to message</span>
              </a>
              <button type="button" class="atmos-btn atmos-btn--sm" (click)="copyLink(result)">
                <mat-icon>link</mat-icon>
                <span>Copy message link</span>
              </button>
              @if (result.canDelete) {
                <button type="button" class="atmos-btn atmos-btn--sm atmos-btn--danger" (click)="onDelete(result)">
                  <mat-icon>delete</mat-icon>
                  <span>Delete</span>
                </button>
              } @else {
                <button type="button" class="atmos-btn atmos-btn--sm atmos-btn--danger" (click)="onReport(result)">
                  <mat-icon>report</mat-icon>
                  <span>Report</span>
                </button>
              }
            </div>
          </div>
        }
        @if (!apiData()?.items?.length) {
          <p class="atmos-paragraph atmos-page__hint">No outfits found for this selection.</p>
        }
      }
    </div>
  </div>
</div>
